import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {IncomeTaxPersonalChildCampOptions,} from '../../../../../../../../../../../common/src/options/calculations/income-tax/personal/common/income-tax-personal-child-camp.options';
import {RrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/rrsp.options";


@Component({
  selector: 'app-rrsp-personal-tax-child-camp-form',
  templateUrl: './rrsp-personal-tax-child-camp-form.component.html',
  styleUrls: ['./rrsp-personal-tax-child-camp-form.component.scss'],
  standalone: false,
})
export class RrspPersonalTaxChildCampFormComponent {

  @Input()
  campForm: AdvancedFormGroup<IncomeTaxPersonalChildCampOptions>;

  @Input()
  index: number;

  @Input()
  form: AdvancedForm<RrspOptions>;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }
}
